import React from "react"

interface Props {
    hasChanges: boolean
    submitting: boolean
    onSubmit: () => void
    disabled?: boolean
}

/**
 * Affiché dès que la cible a des valeurs à enregistrer, même sans modification : à la première
 * config d'un site/marque/combinaison, les valeurs affichées sont héritées du global (cf.
 * showGlobalReference dans VariableFees.tsx par ex.) et l'utilisateur doit pouvoir les valider
 * telles quelles sans être obligé de faire une modif factice pour débloquer le bouton.
 */
export default function UnsavedChangesAlert({ hasChanges, submitting, onSubmit, disabled = false }: Props) {
    return (
        <div className="d-flex flex-row">
            <div className={`alert ${hasChanges ? 'alert-warning' : 'alert-info'} m-0 p-1 mr-1`}>
                <i className={`fa ${hasChanges ? 'fa-warning' : 'fa-info-circle'} mr-1`}></i>
                {hasChanges
                    ? 'Modifications non sauvegardées'
                    : "Aucune modification : l'enregistrement conservera les valeurs actuellement affichées"}
            </div>
            <button type="submit" className="btn btn-primary m-0 p-1" onClick={onSubmit} disabled={disabled || submitting}>
                {submitting && <i className="fa fa-spinner fa-spin fa-fw mr-1"></i>}
                Valider
            </button>
        </div>
    )
}
